import { jsx as a, jsxs as I } from "react/jsx-runtime";
import { selectIconButtonColor as i } from "./index.es776.js";
import O from "classnames";
import { forwardRef as D, useCallback as x, cloneElement as A } from "react";
import { ButtonLoadingIndication as E } from "./index.es778.js";
import S from "./index.es780.js";
import { getButtonAriaLabel as f } from "./index.es779.js";
import m from "./index.es781.js";
import { SmartTooltipWrapper as U } from "./index.es525.js";
import { getDisabledAria as _ } from "./index.es530.js";
import { UtilityChevronIcon as j } from "./index.es439.js";
const w = "icon-button-component", J = D(
  ({
    variant: o = "primary-brand",
    disabled: r = !1,
    Icon: p,
    size: u,
    chevron: l,
    isLoading: t = !1,
    testId: c = w,
    isOnGrayBackground: y,
    "aria-label": s,
    onClick: n,
    tooltip: e,
    isLocked: b,
    ...h
  }, T) => {
    const d = O(S.button, m["button-icon"], {
      [m.isOnGrayBackground]: y,
      [m.loading]: t
    }), B = i(o, r), N = x(
      (g) => {
        t || r || n == null || n(g);
      },
      [r, t, n]
    );
    return /* @__PURE__ */ a(
      U,
      {
        tooltip: e,
        isLocked: b,
        lockedTooltip: e == null ? void 0 : e.lockedTooltip,
        itemLabel: f(s, t),
        isDisabled: r,
        isOverflowing: !1,
        ref: T,
        children: /* @__PURE__ */ I(
          "button",
          {
            className: d,
            "data-testid": c,
            "data-pl-size": u,
            "data-pl-variant": o,
            onClick: N,
            "aria-label": f(s, t),
            ..._(!!r, !!e, "disabled"),
            ...h,
            children: [
              /* @__PURE__ */ a(
                E,
                {
                  isLoading: t,
                  variant: o === "ghost" ? "secondary-gray" : o,
                  testId: c
                }
              ),
              !t && A(p, {
                outline: B,
                color: (o === "secondary-gray" || o === "ghost") && !r ? "gray" : "outline"
              }),
              l && /* @__PURE__ */ a(
                "div",
                {
                  className: m.chevron,
                  "data-testid": `${c}-chevron`,
                  "data-type": "chevron",
                  children: /* @__PURE__ */ a(
                    j,
                    {
                      type: "normal",
                      direction: l.direction,
                      outline: i(o, r)
                    }
                  )
                }
              )
            ]
          }
        )
      }
    );
  }
);
export {
  w as ICON_BUTTON_DEFAULT_TESTID,
  J as IconButton
};
//# sourceMappingURL=index.es16.js.map
